module.exports = "/_next/static/images/buyers_9_en-ffaec0dd64f7336c38a66065fda43a22.png";